import { FormControlNameRecord } from '../../../data-types/form-types';

export const timeDialogFormControls: FormControlNameRecord = {
  DateFrom: 'dateFrom',
  DateTo: 'dateTo',
  TimeFrom: 'timeFrom',
  TimeTo: 'timeTo',
  Interval: 'interval',
  TimeOfDay: 'timeOfDay',
};
